import iconComparisonList from './iconComparisonList';

const requireIcon = require.context('..', true, /\.vue$/, 'lazy');

export function loadSvgIcon(fileName) {
    return requireIcon(`./${fileName}`);
}

const iconKeysByName = Object.create(null);

export const svgIconCatalog = [];

requireIcon.keys().forEach((fileName) => {
    const relativePath = fileName.replace(/^\.\//, '');
    const name = relativePath.replace(/\.vue$/, '').split('/').pop();

    iconKeysByName[name] = fileName;

    svgIconCatalog.push({
        name,
        fileName: relativePath
    });
});

export default function getSvgIconFromClass(cssClass) {
    const name = cssClass && iconComparisonList[cssClass];

    if (!name) {
        return null;
    }

    const key = iconKeysByName[name];

    if (!key) {
        return null;
    }

    return () => requireIcon(key);
}